import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["content", "children"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import React from 'react';
var rootStyles = process.env.NODE_ENV === "production" ? {
  name: "ua4c0o",
  styles: "margin:0;padding:0;color:#17181a;font-size:1.25rem;font-weight:400;letter-spacing:0px;line-height:1.5rem;text-align:center"
} : {
  name: "17sduaz-rootStyles",
  styles: "margin:0;padding:0;color:#17181a;font-size:1.25rem;font-weight:400;letter-spacing:0px;line-height:1.5rem;text-align:center;label:rootStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0RpYWxvZ1RpdGxlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNbUIiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvRGlhbG9nVGl0bGUudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5cbmltcG9ydCB7IGNzcywganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCB0eXBlIHsgRGlhbG9nVGl0bGVQcm9wcyB9IGZyb20gJy4uL3R5cGVzJztcblxuY29uc3Qgcm9vdFN0eWxlcyA9IGNzcyh7XG4gIG1hcmdpbjogJzAnLFxuICBwYWRkaW5nOiAnMCcsXG4gIGNvbG9yOiAnIzE3MTgxYScsXG4gIGZvbnRTaXplOiAnMS4yNXJlbScsXG4gIGZvbnRXZWlnaHQ6IDQwMCxcbiAgbGV0dGVyU3BhY2luZzogJzBweCcsXG4gIGxpbmVIZWlnaHQ6ICcxLjVyZW0nLFxuICB0ZXh0QWxpZ246ICdjZW50ZXInLFxufSk7XG5cbmNvbnN0IERpYWxvZ1RpdGxlOiBSZWFjdC5GQzxEaWFsb2dUaXRsZVByb3BzPiA9ICh7XG4gIGNvbnRlbnQsXG4gIGNoaWxkcmVuLFxuICAuLi51bmhhbmRsZWRQcm9wc1xufSkgPT4gKFxuICA8aDEgey4uLnVuaGFuZGxlZFByb3BzfSBjc3M9e3Jvb3RTdHlsZXN9PlxuICAgIHtjaGlsZHJlbiAhPSBudWxsID8gY2hpbGRyZW4gOiBjb250ZW50fVxuICA8L2gxPlxuKTtcblxuRGlhbG9nVGl0bGUuZGlzcGxheU5hbWUgPSAnRGlhbG9nVGl0bGUnO1xuXG5leHBvcnQgZGVmYXVsdCBEaWFsb2dUaXRsZTtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var DialogTitle = function DialogTitle(_ref) {
  var content = _ref.content,
      children = _ref.children,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return jsx("h1", _extends({}, unhandledProps, {
    css: rootStyles
  }), children != null ? children : content);
};

DialogTitle.displayName = 'DialogTitle';
export default DialogTitle;